module.exports = __webpack_public_path__ + "img/swiper_06.0a6eaaf4.jpg";